<template>
  <div>
    <!-- Navigation -->
    <b-navbar fixed="top" type="dark" toggleable="lg" :class="handleNavScroll" style="transition: 0.2s">
      <div class="container">
        <b-navbar-brand :class="handleTextColorScroll" href="#/">Job Fair - Faculty of Engineering</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">


            <router-link class="nav-link center-fair" :class="handleLinkScroll" to="/">Home</router-link>


            <template v-if="getUserId===`` && getKmuttId===``">
              <router-link class="nav-link mx-2" :class="handleLinkScroll" to="student/login">Student Login
              </router-link>
              <router-link class="nav-link btn btn-engineer px-3" to="company/login">Post a Job</router-link>
            </template>
            <template v-else-if="getUserId !== `` && getCompanyDetail.contact_person">

              <a v-if="!getCompanyDetail.contact_person" class="nav-link"
                 style="display: flex; justify-content: center; align-items: center;" @click="companyUserLogout"
                 :class="handleLinkScroll">Logout
              </a>

              <b-nav-item-dropdown class="no-arrow" right>
                <template v-slot:button-content>
                  <a v-if="getCompanyDetail.contact_person.firstName" class="nav-link" :class="handleLinkScroll"><i
                    class="far fa-user-circle mr-2"></i>
                    K.{{getCompanyDetail.contact_person.firstName}}</a>
                  <a v-else class="nav-link" :class="handleLinkScroll"><i class="far fa-user-circle mr-2"></i>
                    {{getCompanyDetail.email}}</a>
                </template>
                <b-dropdown-item class="nav-link" :class="handleLinkScroll" href="#/company/information">Company
                  Profile
                </b-dropdown-item>
                <b-dropdown-item class="nav-link" :class="handleLinkScroll" @click="companyUserLogout"><i
                  class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i> Logout
                </b-dropdown-item>
              </b-nav-item-dropdown>

            </template>
            <template v-else-if="getKmuttId !== `` && getKmuttStatus !== ``">
              <b-nav-item-dropdown class="no-arrow" right>
                <template v-slot:button-content>
                  <a class="nav-link" :class="handleLinkScroll"><i class="far fa-user-circle mr-2"></i>
                    {{getKmuttId}}</a>
                </template>
                <b-dropdown-item v-if="getKmuttStatus === `admin`" class="nav-link" :class="handleLinkScroll"><i
                  class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                  <router-link class="text-gray-900" style="text-decoration: none;" to="/admin/dashboard">Admin Page
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item class="nav-link" :class="handleLinkScroll" @click="kmuttUserLogout"><i
                  class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i> Logout
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </template>


          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>

    <!-- Full Page Image Header with Vertically Centered Content -->
    <header class="bg-head">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 text-center header-item">
            <div class="header-caption d-none d-md-block text-left">
              <h1 style="font-weight:500; font-size:48px">Put the Right Man <br> on the Right Job</h1>
              <hr class="col-3" style="border-top: 2px solid #fff; margin-left: 0px;">
              <h2 style="font-size:24px">KMUTT Engineering Online Job Fair</h2>
            </div>
          </div>
        </div>
      </div>
    </header>

    <template v-if="isBackend === false">
      <fade-transition :duration="100" origin="center top" mode="out-in">
        <router-view/>
      </fade-transition>
    </template>

    <template v-else>
      <div id="wrapper">

        <!-- Sidebar -- bg-gradient-danger -->
        <ul class="navbar-nav bg-gradient-engineer-re sidebar sidebar-dark accordion transitionToggled"
            :class="sidebarCollapse" id="accordionSidebar">

          <!-- Sidebar - Brand -->
          <a class="sidebar-brand d-flex align-items-center justify-content-center" href="#/">
            <div class="sidebar-brand-icon">
              <!-- rotate-n-15 -->
              <i class="fas fa-inbox"></i>
            </div>
            <div class="sidebar-brand-text my-3 mx-1"> JobFair x KMUTT</div>
          </a>

          <!-- Divider -->
          <hr class="sidebar-divider">

          <!-- Heading -->
          <div class="sidebar-heading">
            {{isCompany ? `ข้อมูลบริษัท` : `ข้อมูลส่วนตัว`}}
          </div>

          <!-- Nav Item - profile -->
          <li class="nav-item" :class="$route.path === `/company/information` ? `active` : ``">
            <router-link class="nav-link" to="/company/information"><i class="fas fa-fw fa-user-alt"></i><span>ข้อมูลเบื้องต้น</span>
            </router-link>
          </li>

          <template v-if="isCompany">
            <!-- Nav Item - jobDescription -->

            <li class="nav-item" :class="$route.path === `/company/description` ? `active` : ``">
              <router-link class="nav-link" to="/company/description"><i class="fas fa-fw fa-building"></i><span>ข้อมูลบริษัท/ตำแหน่งที่รับ</span>
              </router-link>
            </li>

            <!-- Nav Item - jobFair -->
            <li class="nav-item" :class="$route.path === `/company/meeting` ? `active` : ``">
              <router-link class="nav-link" to="/company/meeting"><i class="fas fa-fw fa-briefcase"></i><span>รายละเอียด Jobfair</span>
              </router-link>
            </li>
          </template>


          <!-- Divider -->
          <hr class="sidebar-divider d-none d-md-block">

          <!-- Sidebar Toggler (Sidebar) -->
          <div class="text-center d-none d-md-inline">
            <button class="rounded-circle border-0" id="sidebarToggle" @click="toggled(!sidebarCollapseValue)"></button>
          </div>

        </ul>
        <!-- End of Sidebar -->

        <!-- Content Wrapper -->
        <div id="content-wrapper" class="d-flex flex-column">

          <!-- Main Content -->
          <div id="content">
            <!-- Begin Page Content -->
            <div class="container-fluid mt-4">

              <!--- Notification --->
              <template v-if="getCompanyDetail">
                <div class="row" v-if="getCompanyDetail.status === `pending`">
                  <div class="col-12">
                    <div class="alert alert-info alert-dismissible fade show" role="alert">
                      <strong><i class="fas fa-times-circle mr-2"></i> รอการพิจารณาจากทางคณะ
                        (ไม่สามารถแก้ไขข้อมูลได้)</strong>
                      <!--                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">-->
                      <!--                      <span aria-hidden="true">&times;</span>-->
                      <!--                    </button>-->
                    </div>
                  </div>
                </div>

                <div class="row"
                     v-else-if="getCompanyDetail.status === `approve` || getCompanyDetail.status === `approved`">
                  <div class="col-12">
                    <div class="alert alert-success alert-dismissible fade show" role="alert">
                      <strong><i class="fas fa-check-circle mr-2"></i> ผ่านการพิจารณาจากทางคณะ
                        (สามารถแก้ไขข้อมูลได้)</strong>
                      <!--                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">-->
                      <!--                      <span aria-hidden="true">&times;</span>-->
                      <!--                    </button>-->
                    </div>
                  </div>
                </div>
              </template>


              <!-- Content Row -->
              <div class="row">
                <fade-transition :duration="100" origin="center top" mode="out-in">
                  <router-view/>
                </fade-transition>
              </div>

            </div>
            <!-- /.container-fluid -->

          </div>
          <!-- End of Main Content -->

          <!-- Footer -->
          <footer id="sticky-footer" class="sticky-footer py-2 bg-dark text-white-50">
            <div class="container my-auto">
              <div class="copyright text-center my-auto">
                <p class="my-2">Copyright &copy; 2022, Faculty of Engineering KMUTT</p>
              </div>
            </div>
          </footer>
          <!-- End of Footer -->

        </div>
        <!-- End of Content Wrapper -->

      </div>
    </template>

  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
  import {mapActions, mapGetters, mapState} from "vuex";
import api from "@/services/api";
  export default {
    name: "publicLayout",
    props: {
      isBackend: Boolean,
      isCompany: Boolean
    },
    data() {
      return {
        handleNavScroll: "",
        handleTextColorScroll: "",
        handleLinkScroll: "",
        sidebarCollapse: "",
        sidebarCollapseValue: false
      }
    },
    computed: {
      ...mapGetters(["getUserId", "getStudentId", "getKmuttId", "getKmuttStatus"]),
      ...mapState(["companyData"]),
      getCompanyDetail() {
        return this.companyData
      }
    },
    async mounted() {
      if (firebase.auth().currentUser) {
        let uid = firebase.auth().currentUser.uid;
        await firebase
            .auth()
            .currentUser.getIdToken(false)
            .then(async (idToken) => {
              await api
                  .getCompanyDetial(idToken, {
                    id: uid
                  })
                  .then(res => {
                    let companyData = {
                      data: res.data.data[0],
                      isSuccess: res.data.isSuccess,
                      token: idToken
                    };
                    this.$store.state.companyData = companyData.data;
                    this.$store.state.companyContact = companyData.data.contact_person.firstName;
                    this.$store.state.token = idToken;
                  })
                  .catch(err => {
                    console.log(err);
                  });
            });
      }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      ...mapActions(["logout", "kmuttLogout"]),
      handleScroll() {
        // Any code to be executed when the window is scrolled
        // eslint-disable-next-line no-empty
        if (window.scrollY > 95) {
          this.handleNavScroll = `navbar-light bg-light`;
          this.handleTextColorScroll = `handleTextColorScroll`;
          this.handleLinkScroll = `handleLinkScroll`
        } else {
          this.handleNavScroll = ``;
          this.handleTextColorScroll = ``
          this.handleLinkScroll = ``
        }
      },
      toggled(toggleValue) {
        this.sidebarCollapseValue = toggleValue;
        if (toggleValue) {
          this.sidebarCollapse = `toggled`
        } else {
          this.sidebarCollapse = ``
        }
      },
      kmuttUserLogout() {
        this.kmuttLogout()
          .then(() => {
            this.$router.push({path: "/"})
          })
      },
      companyUserLogout() {
        this.logout()
          .then(() => {
            this.$router.push({path: "/"})
          })
      }
    }
  }
</script>

<style scoped>
  a.nav-link {
    cursor: pointer !important;
  }

  .transitionToggled {
    transition: 0.1s;
  }

  .handleTextColorScroll {
    color: rgba(0, 0, 0, 0.9);
    transition: 0.1s;
  }

  .nav-link.handleLinkScroll, .nav-link.dropdown-toggle {
    color: rgba(0, 0, 0, 0.5);
    transition: 0.1s;
    cursor: pointer;
  }

  .nav-link.handleLinkScroll:hover, .nav-link.handleLinkScroll:focus {
    color: rgba(0, 0, 0, 0.9) !important;
    transition: 0.1s;
    cursor: pointer;
  }

  .nav-link.active.handleLinkScroll {
    color: rgba(0, 0, 0, 0.9);
    transition: 0.1s;
    cursor: pointer;
  }

  .nav-link.btn {
    color: #FFFFFF;
    cursor: pointer;
  }

  .nav-link.btn:hover {
    color: #FFFFFF;
    cursor: pointer;
  }
</style>
<style>
  .handleTextColorScroll:hover, .handleTextColorScroll:focus {
    color: rgba(0, 0, 0, 0.9) !important;
  }

  .dropdown-item.active, .dropdown-item:active {
    color: rgba(0, 0, 0, 0.9);
    background-color: transparent !important;
  }

  .nav-link {
    display: flex;
    justify-content: center;
    align-items: baseline;
  }

  .center-fair {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
